module.exports = __webpack_public_path__ + "static/media/badge-dollar.f085af45.svg";